<template>
  <div>
    <nav-header ref="navHeader"
                v-bind:showSearch="p_showSearch"
                v-bind:loginModalFlag="p_loginModalFlag"
                v-bind:showNavbar="p_showNavbar"
                v-on:showLoginModal="p_showLoginModal"
                v-on:closeLoginModal="p_closeLoginModal"
    ></nav-header>
    <nav-bread>
      <span style="margin-right:10px;" slot="mine">申请退款</span>
    </nav-bread>
    <div class="container">
      <el-container>
        <div class="biaot"><p class="mshow">申请退款</p>
          <nav-left v-bind:activeIndex="p_activeIndex"></nav-left>
        </div>
        <el-container style="margin:40px 0 0 20px;">
          <el-main v-loading="sub_loading">
            <template v-if="applyVisible">
              <div class="infoTit">订单信息</div>
              <div class="infoCon detail_info">
                <p>订单编号：{{orderDesc.orderNum}}</p>
                <p>创建时间：{{orderDesc.addTime}}</p>
                <p>预约日期：{{appt.apptTime}}
                  <template v-if="appt.apptBeginTime">{{appt.apptBeginTime}}~{{appt.apptEndTime}}</template>
                </p>
                <p>受检者：{{appt.apptName}}</p>
                <p>性别：{{appt.apptSex == 1 ? '男' : '女'}}</p>
                <p>手机号：{{appt.apptMobile}}</p>
                <p>{{appt.apptCert == 0 ? '身份证' : '护照'}}号：{{appt.apptCertNo}}</p>
              </div>
              <div class="infoTit">商品信息</div>
              <div class="infoCon">
                <el-table
                  :data="orderDetailList"
                  border
                  style="width: 100%">
                  <el-table-column
                    prop="itemName"
                    label="商品信息">
                  </el-table-column>
                  <el-table-column
                    prop="specPrice"
                    label="单价">
                  </el-table-column>
                  <el-table-column
                    prop="spec"
                    label="规格">
                  </el-table-column>
                  <el-table-column
                    prop="itemNum"
                    label="数量">
                  </el-table-column>
                </el-table>
              </div>
              <div class="infoTit">申请退款</div>
              <!--PC-->
              <div v-if="IsPC" class="infoCon" id="dataForm">
                <el-form ref="dataForm" :model="dataForm" :rules="dataRule"
                         label-position="left" label-width="100px">
                  <el-form-item label="退款原因" prop="reasonType">
                    <el-select v-model="dataForm.reasonType" placeholder="请选择" clearable @change="changeReasonType">
                      <el-option label="多拍/拍错/不想要了" value="多拍/拍错/不想要了"></el-option>
                      <el-option label="行程有变化" value="行程有变化"></el-option>
                      <el-option label="其他" value="其他"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item v-if="dataForm.reasonType === '其他'" prop="reason">
                    <el-input v-model="dataForm.reason" placeholder="请填写其他退款原因" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="退款金额" prop="refundPrice">
                    <el-input v-model="dataForm.refundPrice" :disabled="true"></el-input>
                    <el-popover
                      placement="right"
                      trigger="hover"
                      width="200px"
                      content="按实付金额退款，如订单使用优惠券，优惠券不支持返还">
                      <img slot="reference" class="question_icon" src="../../assets/question_icon.png">
                    </el-popover>
                  </el-form-item>
                  <el-form-item label="备注">
                    <el-input type="textarea" :rows="6" placeholder="退款说明" v-model="dataForm.remark" maxlength="200"
                              show-word-limit></el-input>
                  </el-form-item>
                  <el-form-item>
                    <a class="cancelBtn" @click="toOrderList()">取消</a>
                    <a class="submitBtn" @click="submit()">提交</a>
                  </el-form-item>
                </el-form>
              </div>
              <!--移动-->
              <div v-else class="infoCon" id="dataForm_mb">
                <el-form ref="dataForm" :model="dataForm" :rules="dataRule"
                         label-position="left" label-width="100px">
                  <el-form-item label="退款原因" prop="reasonType">
                    <p @click="openQuestionType()">{{dataForm.reasonType ? dataForm.reasonType : '请选择'}}<i
                      class="el-icon-arrow-right"></i></p>
                  </el-form-item>
                  <el-form-item v-if="dataForm.reasonType === '其他'" prop="reason">
                    <el-input placeholder="请填写其他退款原因" v-model="dataForm.reason" maxlength="200"></el-input>
                  </el-form-item>
                  <el-form-item label="退款金额" prop="refundPrice">
                    <p>￥{{dataForm.refundPrice}}</p>
                  </el-form-item>
                  <el-form-item label="备注" style="padding-left: 10px;">
                    <el-input placeholder="退款说明" v-model="dataForm.remark" maxlength="200"></el-input>
                  </el-form-item>
                </el-form>
                <mt-popup v-model="popupVisible" popup-transition="popup-fade" closeOnClickModal="true"
                          position="bottom">
                  <mt-picker :slots="popupSlots" @change="onValuesChange" showToolbar>
                    <div class="picker-toolbar-title">
                      <div class="usi-btn-cancel" @click="popupVisible = !popupVisible">取消</div>
                      <div class="">请选择退款原因</div>
                      <div class="usi-btn-sure" @click="popupOk()">确定</div>
                    </div>
                  </mt-picker>
                </mt-popup>
                <div class="actionBtn">
                  <a class="cancelBtn" @click="toOrderList()">取消</a>
                  <a class="submitBtn" @click="submit()">提交</a>
                </div>
              </div>
            </template>
            <div v-else class="applySuccess">
              <img src="../../assets/ok_icon.png">
              <h3>提交成功！</h3>
              <p>请耐心等待检验所处理</p>
              <a class="actionBtn" @click="toHome()">回首页</a>
              <a class="actionBtn" @click="toOrderList()">我的订单</a>
            </div>
          </el-main>
        </el-container>
      </el-container>
    </div>
  </div>
</template>

<script>
  import NavLeft from '@/components/NavLeft.vue'
  import NavHeader from '@/components/Header'
  import NavBread from '@/components/Bread.vue'
  import axios from 'axios'
  import {getCookie, IsPC} from "../../util/util";

  export default {
    name: "applyRefund",
    data() {
      return {
        p_activeIndex: "1",
        p_showSearch: true,
        p_loginModalFlag: false,
        p_showNavbar: true,
        sub_loading: false,
        applyVisible: true,
        orderId: this.$route.query.id,
        orderType: this.$route.query.orderType,
        orderDesc: '',
        orderDetailList: [],
        appt: {},
        dataForm: {
          reasonType: '',
          reason: '',
          refundPrice: '',
          remark: ''
        },
        dataRule: {
          reasonType: [
            {required: true, pattern: '[^ \x22]+', message: '退款原因不能为空'}
          ],
          reason: [
            {required: true, pattern: '[^ \x22]+', message: '退款原因不能为空'}
          ],
          refundPrice: [
            {required: true}
          ]
        },
        popupVisible: false,
        questionTypeVal: '',
        popupSlots: [
          {
            values: [
              '多拍/拍错/不想要了', '行程有变化', '其他'
            ]
          }
        ]
      }
    },
    components: {
      NavLeft,
      NavHeader,
      NavBread
    },
    computed: {
      IsPC() {
        return IsPC()
      }
    },
    mounted() {
      if (getCookie("_token")) {
        this.getOrderInfo()
        this.$nextTick(() => {
          this.$refs['dataForm'].resetFields()
        })
      } else {
        this.$message({
          showClose: true,
          message: '登录信息失效,请重新登录',
          type: 'error'
        });
        this.$refs.navHeader.logout()
      }
    },
    methods: {
      p_showLoginModal() {
        this.p_loginModalFlag = true
      },

      p_closeLoginModal() {
        this.p_loginModalFlag = false
      },

      getOrderInfo() {
        let requestUrl = this.orderType == 1 ? "/jys/order/info/" : "/jys/order/channelHospital/"
        axios.get(requestUrl + this.orderId).then((res) => {
          if (res.data.code === 0) {
            this.orderDesc = res.data.order
            this.dataForm.refundPrice = this.orderDesc.payPrice
            this.orderDetailList = res.data.order.orderDetailList
            // 预约信息
            if (res.data.appt) {
              res.data.appt.apptTime = res.data.appt.apptTime.substring(0, 10)
            }
            this.appt = res.data.appt
          }
        })
      },

      submit() {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            this.sub_loading = true
            axios.post("/re/appt/refund", {
              userId: this.$store.state.user.userId,
              orderId: this.orderId,
              reason: this.dataForm.reasonType === '其他' ? this.dataForm.reason : this.dataForm.reasonType,
              refundPrice: this.dataForm.refundPrice,
              remark: this.dataForm.remark,
              type: 1,
              platform: 1
            }).then((res) => {
              this.sub_loading = false
              if (res.data.code === 0) {
                this.applyVisible = false
              } else {
                this.$message.error(res.data.msg)
              }
            })
          }
        })
      },

      toHome() {
        this.$router.push("/")
      },

      toOrderList() {
        this.$router.replace("/mine/orderList")
      },

      changeReasonType() {
        this.dataForm.reason = ''
      },

      openQuestionType() {
        this.popupVisible = true
      },

      popupOk() {
        this.dataForm.reasonType = this.questionTypeVal
        this.popupVisible = false
        if (this.questionTypeVal !== '其他') {
          this.dataForm.reason = ''
        }
      },

      onValuesChange(picker, values) {
        this.questionTypeVal = values[0]
      }
    }
  }
</script>

<style scoped>
  .mshow {
    display: none;
  }

  .el-main {
    padding: 20px 0;
  }

  .infoTit {
    width: 100%;
    background: #F0F0F0;
    line-height: 40px;
    padding-left: 30px;
    color: #000000;
  }

  .infoCon {
    padding: 20px 30px;
  }

  .detail_info {
    line-height: 30px;
  }

  #dataForm >>> .el-textarea,
  #dataForm >>> .el-input {
    width: 300px;
  }

  #dataForm .cancelBtn {
    display: inline-block;
    width: 140px;
    text-align: center;
    line-height: 35px;
    border: 1px solid #c0c4cc;
    border-radius: 5px;
    margin-right: 20px;
  }

  #dataForm .submitBtn {
    display: inline-block;
    width: 140px;
    text-align: center;
    line-height: 35px;
    background-color: #00C8B2;
    color: #FFFFFF;
    border-radius: 5px;
  }

  #dataForm .question_icon {
    position: absolute;
    top: 9px;
    left: 310px;
    width: 14px;
    height: 14px;
    cursor: pointer;
  }

  #dataForm_mb {
    margin-bottom: 70px;
  }

  #dataForm_mb .actionBtn {
    position: fixed;
    width: 100%;
    left: 0;
    bottom: 0;
    padding: 15px;
    background-color: #FFFFFF;
  }

  #dataForm_mb .cancelBtn {
    display: inline-block;
    width: 45%;
    text-align: center;
    line-height: 35px;
    border: 1px solid #c0c4cc;
    border-radius: 5px;
    margin: 0 2%;
  }

  #dataForm_mb .submitBtn {
    display: inline-block;
    width: 45%;
    text-align: center;
    line-height: 35px;
    background-color: #00C8B2;
    color: #FFFFFF;
    border-radius: 5px;
    margin: 0 2%;
  }

  #dataForm_mb .el-form-item {
    margin-bottom: 0;
    padding: 5px 0;
    border-bottom: 1px solid #dddddd;
  }

  #dataForm_mb .el-form-item p {
    text-align: right;
  }

  #dataForm_mb .el-form-item >>> .el-input__inner {
    border: none;
    padding-right: 0;
    text-align: right
  }

  #dataForm_mb .el-form-item :-moz-placeholder {
    text-align: right;
  }

  #dataForm_mb .el-form-item ::-moz-placeholder {
    text-align: right;
  }

  #dataForm_mb .el-form-item ::-webkit-input-placeholder {
    text-align: right;
  }

  #dataForm_mb .el-form-item :-ms-input-placeholder {
    text-align: right;
  }

  #dataForm_mb .mint-popup {
    width: 100%;
  }

  .picker-toolbar-title {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    background-color: #eee;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
  }

  #dataForm_mb >>> .picker-item {
    font-size: 14px;
  }

  #dataForm_mb >>> .el-form-item__error {
    left: unset;
    right: 0;
  }

  .applySuccess {
    margin-top: 50px;
    text-align: center;
  }

  .applySuccess img {
    width: 100px;
    height: 100px;
  }

  .applySuccess h3 {
    margin: 20px 0
  }

  .applySuccess p {
    margin-bottom: 20px;
  }

  .applySuccess .actionBtn {
    display: inline-block;
    width: 80px;
    padding: 5px 0;
    color: #00C8B2;
    border: 1px solid #00C8B2;
    border-radius: 5px;
    cursor: pointer;
    margin: 0 10px;
  }

  @media only screen and (min-width: 320px) and (max-width: 767px) {
    /deep/ .container {
      width: 95%;
    }

    /deep/ .el-container {
      margin: 0 !important;
    }

    .biaot {
      background-color: #F0F0F0;
      color: #333;
      font-size: 11px;
      text-align: left;
      position: relative;
      line-height: 32px;
      margin: 0 -10px;
      padding: 0 10px;
      border-left: 5px solid #00C5B0;
    }

    .biaot div {
      position: absolute;
      right: 0;
      height: 32px;
      top: 0;
    }

    .mshow {
      display: inline-block;
    }

    .mhide {
      display: none;
    }

    /deep/ .navbar-right-container, /deep/ .navbar-left-container img, /deep/ .hideel {
      display: none !important;
    }

    /deep/ .out {
      color: rgba(0, 196, 170, 1);
      padding-left: 0;
      margin-right: 20px;
    }

    .infoTit {
      font-size: 12px;
      line-height: 30px;
      padding-left: 10px;
    }

    .infoCon {
      padding: 20px 10px;
    }

    .detail_info {
      font-size: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/ApplyRefund.vue